import type { SVGProps } from 'react';

export const IntegrationsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M10.9997 6.66653C10.9997 9.05976 9.05963 10.9999 6.66641 10.9999C4.27318 10.9999 2.33308 9.05976 2.33308 6.66653C2.33308 4.2733 4.27318 2.33321 6.66641 2.33321C9.05963 2.33321 10.9997 4.2733 10.9997 6.66653ZM18.333 15.9998H20.6664C21.2184 15.9998 21.6664 16.4478 21.6664 16.9998C21.6664 17.5518 21.2184 17.9998 20.6664 17.9998H18.333V20.3332C18.333 20.8852 17.885 21.3332 17.333 21.3332C16.781 21.3332 16.333 20.8852 16.333 20.3332V17.9998H13.9997C13.4477 17.9998 12.9997 17.5518 12.9997 16.9998C12.9997 16.4478 13.4477 15.9998 13.9997 15.9998H16.333V13.6665C16.333 13.1145 16.781 12.6665 17.333 12.6665C17.885 12.6665 18.333 13.1145 18.333 13.6665V15.9998ZM17.333 10.9999C19.7263 10.9999 21.6664 9.05976 21.6664 6.66653C21.6664 4.2733 19.7263 2.33321 17.333 2.33321C14.9398 2.33321 12.9997 4.2733 12.9997 6.66653C12.9997 9.05976 14.9398 10.9999 17.333 10.9999ZM10.9997 17.3332C10.9997 19.7264 9.05963 21.6665 6.66641 21.6665C4.27318 21.6665 2.33308 19.7264 2.33308 17.3332C2.33308 14.9399 4.27318 12.9998 6.66641 12.9998C9.05963 12.9998 10.9997 14.9399 10.9997 17.3332Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
